import React from 'react';
import { withRouter } from 'react-router';
import Sidebar from '../components/layout/sidebar/Sidebar.jsx';
import RegisterLead from '../components/sendEmail/registerLead/RegisterLead';

const registerLead = () => {
	return (
		<div>
			<RegisterLead />
			<Sidebar />
		</div>
	);
};

export default withRouter(registerLead);
